import { Box, Typography, TextField } from "@mui/material";
import { ManualEntryData } from "../../../../utils";

interface BilletDetailsFormProps {
  entryData: ManualEntryData;
  onEntryChange: (field: keyof ManualEntryData, value: string) => void;
  isOperating: boolean;
  standalone?: boolean; // When false, used inside combined column
}

export const BilletDetailsForm = ({
  entryData,
  onEntryChange,
  isOperating,
  standalone = true,
}: BilletDetailsFormProps) => {
  const content = (
    <>
      {standalone && (
        <Typography
          variant="h6"
          sx={{
            fontSize: "18px",
            fontWeight: 700,
            color: (theme) => theme.palette.text.primary,
            marginBottom: "16px",
            paddingBottom: "12px",
            borderBottom: (theme) =>
              `2px solid ${theme.palette.billetYard.borders.light}`,
            textAlign: "center",
          }}
        >
          Billet Details
        </Typography>
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        <TextField
          label="Heat Number"
          value={entryData.heatNumber}
          onChange={(e) => onEntryChange("heatNumber", e.target.value)}
          variant="outlined"
          size="medium"
          disabled={isOperating}
          slotProps={{
            input: {
              sx: { fontSize: 16 },
            },
            inputLabel: {
              sx: { fontSize: 16 },
            },
            htmlInput: { maxLength: 6 }, // Matching old system maxLength constraint
          }}
        />

        <TextField
          label="Length"
          type="number"
          value={entryData.length}
          onChange={(e) => onEntryChange("length", e.target.value)}
          variant="outlined"
          size="medium"
          disabled={isOperating}
          slotProps={{
            input: {
              sx: { fontSize: 16 },
            },
            inputLabel: {
              sx: { fontSize: 16 },
            },
          }}
        />

        <TextField
          label="Billets Count"
          type="number"
          value={entryData.billetsCount}
          onChange={(e) => onEntryChange("billetsCount", e.target.value)}
          variant="outlined"
          size="medium"
          disabled={isOperating}
          placeholder="1"
          slotProps={{
            input: {
              sx: { fontSize: 16 },
            },
            inputLabel: {
              sx: { fontSize: 16 },
            },
            htmlInput: { min: 1 },
          }}
        />
      </Box>
    </>
  );

  if (standalone) {
    return (
      <Box
        sx={{
          width: "18%",
          height: "100%",
          marginLeft: "0.5%",
          marginRight: "0.5%",
          background: (theme) => theme.palette.billetYard.backgrounds.gradient,
          border: (theme) =>
            `1px solid ${theme.palette.billetYard.borders.light}`,
          borderRadius: "12px",
          padding: "16px",
          overflowY: "auto",
          boxShadow: (theme) => theme.shadows[2],
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}
      >
        {content}
      </Box>
    );
  }

  return content;
};
